import React from 'react';
import { SanitizedHtml } from '.';


export const Attention = React.memo(({instr,pillText,title}) => {
  return (
    <div className="dinfos-attention">

      <h2 className="dinfos-attention__title">{title}</h2>

      <hr className="dinfos-hr dinfos-hr--gold mx-auto" />

      { pillText ? 
        <div className="dinfos-pill">
          {pillText}
        </div>
      : '' }

      <div className="dinfos-attention__instr">
        <SanitizedHtml content={instr} />
      </div>

      <button type="button" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action" data-next-screen="true">Start</button>
      <button type="button" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action d-none" data-resume="true">Resume</button>

    </div>
  )
})